// utils/auth.js o donde prefieras
import axios from 'axios';
import store from '@/store';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);




let isRefreshing = false;

export async function refreshTokenIfNeeded() {
  const expiryStr = store.getters['auth/tokenExpiry'];
  const token = store.state.auth.token;

  const expiryFormatted = expiryStr ? dayjs(expiryStr).format('YYYY-MM-DD HH:mm:ss') : 'N/A';

  //console.log("🔍 Verificando necesidad de refresh");
  //console.log("Token:", token);
  //console.log("Expiración (legible):", expiryFormatted);

  if (!token || !expiryStr) {
    //console.log("⛔ No hay token o expiración");
    return;
  }

  const now = dayjs().tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const expiry = dayjs(expiryStr).tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const secondsLeft = expiry.diff(now, 'second');

  if (secondsLeft >= 10 || isRefreshing) {
      //console.log("✅ No es necesario refrescar (aún válido o ya refrescando)");
    return; // Token aún es válido o ya se está refrescando
  }

  const user = store.getters['auth/user'];
  //const email = user?.mail;
/*
  if (!email) {
    console.error("Email is undefined. Cannot refresh token.");
    store.dispatch('auth/logout');
    throw new Error("No email to refresh token");
  }*/

  try {
    isRefreshing = true;
    //console.log("🔄 Refrescando token para:", email);

    const { data } = await axios.get(`/v1/refresh`);
    const newToken = data.token;

    await store.dispatch('auth/login', {
      token: newToken,
      user: store.state.auth.user
    });

    //console.log("✅ Nuevo token recibido:", newToken);
  } catch (error) {
    console.error("🚫 Error refrescando token:", error);
    store.dispatch('auth/logout');
    window.location.href = '/login';
    throw error;
  } finally {
    isRefreshing = false;
  }
}
